// extracted by mini-css-extract-plugin
module.exports = {"IconBox":"IconBox-module--IconBox--17K-6","Title":"IconBox-module--Title--3AVRg","Text":"IconBox-module--Text--1t14j","IconContainer":"IconBox-module--IconContainer--1drjy"};